/* eslint-disable @angular-eslint/no-output-on-prefix */

import {
  booleanAttribute,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  output,
  viewChild,
} from '@angular/core';
import {
  FormControl,
  ReactiveFormsModule,
  ValidationErrors,
} from '@angular/forms';
import { FloatLabelType } from '@angular/material/form-field';

import {
  MatSelect,
  MatSelectChange,
  MatSelectModule,
} from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

import { DEFAULT_ERROR_STATE_MATCHER_PROVIDER } from './providers';
import { CanAutoFocusDirective } from './directives';
import { ErrorMessagePipe } from '@shared/pipes';
import { ControlValueAccessorDirective } from '@shared/directives';
@Component({
  selector: 'app-ccs-select',
  templateUrl: './ccs-select.component.html',
  imports: [
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    ErrorMessagePipe,
    CanAutoFocusDirective,
  ],
  hostDirectives: [ControlValueAccessorDirective],
  providers: [DEFAULT_ERROR_STATE_MATCHER_PROVIDER],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcsSelectComponent<T> {
  @Input({ required: true }) label = '';
  @Input({ required: true }) options: T[] = [];
  @Input({ required: true }) valueKey!: keyof T;
  @Input({ required: true }) displayKey!: keyof T;
  @Input({ required: false }) floatLabel: FloatLabelType = 'always';
  @Input({ required: false }) placeholder = '';
  @Input({ required: false }) hint = '';
  @Input({ required: false }) errorMessages: ValidationErrors | null = null;
  @Input({ required: false }) size: 'xs' | 'sm' | 'md' | 'lg' = 'sm';
  @Input({ required: false, transform: booleanAttribute }) autofocus = false;
  @Input({ required: false, transform: booleanAttribute }) multiple = false;

  private readonly _va = inject(ControlValueAccessorDirective);

  public readonly element = viewChild(MatSelect);
  public readonly cdr = inject(ChangeDetectorRef);
  public onFocus = output<FocusEvent>();
  public onBlur = output<FocusEvent>();
  public onSelectionChange = output<MatSelectChange>();
  public onOpenedChange = output<boolean>();

  get control(): FormControl<T | null> {
    return this._va.control;
  }
}
